export default "__VITE_ASSET__BX_vaso6__"